import ListRfqQuoteContentsOfRfq from '../../../../../../client/src/rfq/src/viewmodel/ListRfqQuoteContentsOfRfqViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesListRfqQuoteContentsOfRfq extends DesBaseRfq {

    constructor() {
        console.log('DesRfqQuoteContentsOfRfq invoked');
        super(ListRfqQuoteContentsOfRfq);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}
if (!window.customElements.get('des-list-rfq-quote-contents-of-rfq')) {
    window.customElements.define('des-list-rfq-quote-contents-of-rfq', DesListRfqQuoteContentsOfRfq);
}
